import { api } from './client'
import type { ApiResponse } from '@/services/types/common'

interface AuthNonceResp {
  nonce: string
  /** 该地址是否已注册。false 表示本次连接会创建新账号 */
  registered: boolean
  /** 后台开关：是否必须通过邀请链接注册 */
  inviteCodeRequired: boolean
}

interface AuthConnectResp {
  token: string
  expiresAt: number
  user: import('@/services/types/user').UserInfo
  isNewUser: boolean
}

export const authApi = {
  nonce: (address: string) =>
    api.post<ApiResponse<AuthNonceResp>>('/auth/nonce', { address }),
  connect: (params: { address: string; signature: string; nonce: string; inviteCode?: string }) =>
    api.post<ApiResponse<AuthConnectResp>>('/auth/connect', params),
}
